<template>
    <div class="spotlight">
        <div class="cursor"></div>
        <div class="shapes">
            <div class="shape shape-1"></div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import gsap from 'gsap';

// Mousemove event handler
const handleMouseMove = (evt) => {
    const mouseX = evt.clientX;
    const mouseY = evt.clientY;

    gsap.set(".cursor", {
        x: mouseX,
        y: mouseY
    });

    gsap.to(".shape", {
        x: mouseX,
        y: mouseY,
        stagger: -0.5,
        opacity: 1,
        duration: 0.3,
    });
};

const handleMouseLeave = () => {
    gsap.to(".shape", {
        opacity: 0, // Hide the shape when the mouse leaves
        duration: 0.3
    });
};

// Lifecycle hook to add and remove event listener
onMounted(() => {
    document.querySelector('.main').addEventListener("mousemove", handleMouseMove);
    document.querySelector('.main').addEventListener("mouseleave", handleMouseLeave);
});

onUnmounted(() => {
    document.querySelector('.main').removeEventListener("mousemove", handleMouseMove);
    document.querySelector('.main').removeEventListener("mouseleave", handleMouseLeave);

});

</script>

<style scoped lang="scss">

.spotlight{
    position: absolute;
    pointer-events: none;
    z-index: -10;
}

.shape {
    will-change: transform;
    position: absolute;
    border-radius: 50%;
    mix-blend-mode: screen;

    &.shape-1 {
        background-color: #FBA627;
        width: 260px;
        height: 260px;
        margin: calc(-700px/2) 0 0 calc(-700px/2);
        filter: blur(75px);
        mix-blend-mode: multiply;

    }
}

.cursor {
    position: fixed;
    margin: -10px 0 0 -10px;
    border-radius: 50%;
    will-change: transform;
    user-select: none;
    pointer-events: none;
    z-index: 10000;
}

</style>